// Enum that defined the types of formats allowed to show price changes on dashboard
const FORMAT_TYPE = {
  PERCENTAGE: 'PERCENTAGE',
  CURRENCY: 'CURRENCY',
};

export default FORMAT_TYPE;
